// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleI18n } from '@platform/core/types/modularity/IModuleI18n';
import type { IModuleManifest } from '@platform/core/types/modularity/IModuleManifest';

/** Пакет модуля «Юридичний радник» (Legal Advisor, ключ `lad`, група `legal`). */
export const legalAdvisorManifest: IModuleManifest = {
  key: 'lad',
  group: 'legal',
  slug: 'legal-advisor',
  prefix: 'LAD',
  name: { en: 'Legal Advisor', uk: 'Юридичний радник' },
  entities: [
    { key: 'lad', slug: 'lad', name: { en: 'Legal Advisor', uk: 'Юридичний радник' }, main: true },
    { key: 'question_opinion', slug: 'question-opinion', name: { en: 'Question Opinions', uk: 'Висновки' }, main: false },
    { key: 'question_citation', slug: 'question-citation', name: { en: 'Question Citations', uk: 'Цитування' }, main: false },
    { key: 'question_reviewer', slug: 'question-reviewer', name: { en: 'Question Reviewers', uk: 'Рецензенти' }, main: false },
  ],
  loadState: () => import('./state/legalAdvisorSlice').then((m) => m.legalAdvisorSlice),
  loadI18n: (lng) => (lng === 'uk' ? import('./i18n/uk.json') : import('./i18n/en.json')).then((m) => m.default as IModuleI18n),
  loadDefinition: () => import('./definition').then((m) => m.definition),
};
